import { render, staticRenderFns } from "./PaDeptEdit.vue?vue&type=template&id=ccec60a2&scoped=true"
import script from "./PaDeptEdit.vue?vue&type=script&lang=js"
export * from "./PaDeptEdit.vue?vue&type=script&lang=js"
import style0 from "./PaDeptEdit.vue?vue&type=style&index=0&id=ccec60a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccec60a2",
  null
  
)

export default component.exports